export let CrmJsonData = {
    "processType": "NonPo",
    "processName": "crm",
    "defaultActive": false,
    "schema": {
        "fields": {
            "postingDate": {
                "type": "string",
                "min": 1,
                "required": false,
                "isEditable": true,
                "visible": true
            },
            "Currency": {
                "type": "string",
                "min": 1,
                "required": false,
                "isEditable": true,
                "visible": true
            },
            "Header_Text": {
                "type": "string",
                "min": 1,
                "required": false,
                "isEditable": true,
                "visible": true
            },

            "Company_Code": {
                "type": "string",
                "min": 1,
                "required": true,
                "isEditable": true,
                "visible": true
            },
            "Vendor_Code": {
                "type": "string",
                "min": 1,
                "required": true,
                "isEditable": true,
                "visible": true
            },
            "Vendor_Name": {
                "type": "string",
                "min": 1,
                "required": true,
                "isEditable": true,
                "visible": true
            },
            "Invoice_Number": {
                "type": "string",
                "min": 1,
                "required": true,
                "isEditable": true,
                "visible": true
            },
            "Invoice_Date": {
                "type": "string",
                "min": 1,
                "required": true,
                "isEditable": true,
                "visible": true
            },
            "Grand_Total": {
                "type": "string",
                "min": 1,
                "required": true,
                "isEditable": true,
                "visible": true
            }
        }
    },
    "__v": 1,
    "triggers": [
        {
            "approval": [
                "approved"
            ],
            "level": [
                "level-6"
            ],
            "isActive": true,
            "action": "url",
            "authenticate": false,
            "authType": "credential",
            "userName": "",
            "password": "",
            "token": "",
            "username": "",
            "method": "https://invoiceuat.emcure.com/appsubmission/crm/updateandpost/"
        }
    ],
    "levels": 6,
    "documentType": "document",
    "table": [
        {
            "isActive": true,
            "dateActive": true,
            "filterActive": true,
            "searchActive": true,
            "header": {
                "label": "Records",
                "isActive": true
            },
            "isPaginate": {
                "paginationLimit": 20,
                "isActive": true
            },
            "action": {
                "view": false,
                "edit": false,
                "delete": false,
                "downloadPDF": false,
                "downloadExcel": false
            },
            "columnNameUpperCase": true,
            "columnName": [
                {
                    "key": "documentId",
                    "label": "document Id",
                    "isActive": true,
                    "isFile": false,
                    "fileView": false,
                    "fileDownload": false,
                    "sortActive": false,
                    "tooltipActive": false,
                    "tooltipLabel": "",
                    "truncatedActive": true,
                    "labelCenter": false,
                    "labelNoWrap": false,
                    "rowType": "text",
                    "fieldType": "string"
                },
                {
                    "key": "sapDocumentNumber",
                    "label": "Sap Number",
                    "fieldType": "string",
                    "isActive": true,
                    "tooltipLabel": "",
                    "rowType": "text",
                    "truncatedActive": true,
                    "tooltipActive": false,
                    "labelCenter": false,
                    "labelNoWrap": false
                },
                {
                    "key": "Company_Code",
                    "label": "company Code",
                    "fieldType": "string",
                    "isActive": true,
                    "tooltipLabel": "",
                    "rowType": "text",
                    "tooltipActive": false,
                    "truncatedActive": true,
                    "labelCenter": false,
                    "labelNoWrap": false
                },
                {
                    "key": "Vendor_Code",
                    "label": "Vendor Code",
                    "fieldType": "string",
                    "isActive": true,
                    "tooltipLabel": "",
                    "rowType": "text",
                    "tooltipActive": false,
                    "truncatedActive": true,
                    "labelCenter": false,
                    "labelNoWrap": false
                },
                {
                    "key": "Invoice_Number",
                    "label": "invoice No",
                    "fieldType": "string",
                    "isActive": true,
                    "tooltipLabel": "",
                    "rowType": "text",
                    "truncatedActive": true,
                    "tooltipActive": false,
                    "labelCenter": false,
                    "labelNoWrap": false
                },
                {
                    "key": "Grand_Total",
                    "label": "grand Total",
                    "fieldType": "string",
                    "isActive": true,
                    "tooltipLabel": "",
                    "rowType": "text",
                    "truncatedActive": true,
                    "tooltipActive": false,
                    "labelCenter": false,
                    "labelNoWrap": false
                },
                {
                    "key": "Currency",
                    "label": "currency",
                    "fieldType": "string",
                    "isActive": true,
                    "tooltipLabel": "",
                    "rowType": "text",
                    "truncatedActive": true
                },
                {
                    "key": "Status",
                    "label": "Status",
                    "fieldType": "string",
                    "isActive": true,
                    "tooltipLabel": "",
                    "truncatedActive": true,
                    "rowType": "text",
                    "tooltipActive": false,
                    "labelCenter": false,
                    "labelNoWrap": false
                },
                {
                    "key": "postingMessage",
                    "label": "postingMessage",
                    "fieldType": "string",
                    "isActive": true,
                    "tooltipLabel": "",
                    "rowType": "text",
                    "truncatedActive": true,
                    "tooltipActive": false,
                    "labelCenter": false,
                    "labelNoWrap": false
                },
                {
                    "key": "comments",
                    "label": "Comment",
                    "isActive": true,
                    "isFile": false,
                    "fileView": false,
                    "fileDownload": false,
                    "sortActive": false,
                    "tooltipActive": false,
                    "tooltipLabel": "",
                    "truncatedActive": true,
                    "labelCenter": false,
                    "labelNoWrap": false,
                    "rowType": "text",
                    "fieldType": "string"
                },
                {
                    "key": "created_At",
                    "label": "Created At",
                    "isActive": true,
                    "isFile": false,
                    "fileView": false,
                    "fileDownload": false,
                    "sortActive": false,
                    "tooltipActive": true,
                    "tooltipLabel": "",
                    "truncatedActive": true,
                    "labelCenter": false,
                    "labelNoWrap": false,
                    "rowType": "text",
                    "fieldType": "string"
                },
                {
                    "key": "updated_At",
                    "label": "Action At",
                    "isActive": true,
                    "isFile": false,
                    "fileView": false,
                    "fileDownload": false,
                    "sortActive": false,
                    "tooltipActive": true,
                    "tooltipLabel": "",
                    "truncatedActive": true,
                    "labelCenter": false,
                    "labelNoWrap": false,
                    "rowType": "text",
                    "fieldType": "string"
                }
            ],
            "drawerTable": [
                {
                    "label": "",
                    "isActive": true,
                    "labelCenter": false,
                    "labelNoWrap": false,
                    "rowNoWrap": false,
                    "rowType": "text"
                }
            ]
        }
    ],
    "logo": {
        "name": "logo.png",
        "file": ""
    },
    "notification": [
        {
            "level": [
                "level-1",
                "level-2",
                "level-3",
                "level-4",
                "level-5",
                "level-6"
            ],
            "approval": [
                "approved",
                "rejected"
            ],
            "isActive": true,
            "type": [
                "email",
                "notification"
            ]
        }
    ],
    "showAdditionalForm": [
        "level-1",
        "level-2",
        "level-3",
        "level-4",
        "level-5",
        "level-6",
        "admin"
    ],
    "fieldsToDisable": [
        "level-1",
        "level-2"
    ],
    "canAdditionalDocument": [],
    "bulkApproveApproval": false,
    "bulkRejectApproval": false,
    "updateFirstUserNotification": false,
    "differentiateFirstLevel": false,
    "reset_to_level_1": true,
    "onboarding": false,
    "sortBy": [
        {
            "mode": -1,
            "isActive": true,
            "key": "created_At"
        }
    ],
    "dateFilter": {
        "filterKey": "created_At",
        "rangeActive": true,
        "range": "0-9",
        "showFilter": true,
        "rangePicker": true
    },
    "fileViewer": {
        "show": true,
        "editable": true,
        "tableFile": false,
        "approvalModalOption": "schema",
        "showValue": true,
        "showApprHistory": true
    },
    "withdrawalApproval": [],
    "withdrawalLevel": [],
    "forwardDocument": false,
    "forwardDocumentLevel": [],
    "searchFilter": {
        "key": "invoiceNo"
    },
    "filters": []
}
